import normalMode from "../../normalMode";
import {RegisterSpecialEventEntity} from "../../manager/NormalGameManager";
import O1HD from "../../../../engines/gameEngine";
import {EventParamsTypeConstant} from "../const/EventParamsTypeConstant";

const {ccclass, property} = cc._decorator;
/**
 * 幸运大乐透 事件触发
 */
@ccclass
export default class LotteryEventShow extends cc.Component {

    @property(cc.Label)
    lbDesc : cc.Label = null;
    @property(cc.Label)
    lbTitle : cc.Label = null;
    @property(cc.Node)
    moneyNode : cc.Node = null;
    @property(cc.Node)
    userNode : cc.Node = null;


    private mParentScript : normalMode ;
    private mEventEntity : RegisterSpecialEventEntity;

    onLoad () {}

    start () {
        // this.node.scale = 0.1;
        // cc.tween(this.node).to(.5,{scale:1},{easing:cc.easing.backOut}).start();
    }

    bindData( eventEntity : RegisterSpecialEventEntity , gameLayer : normalMode  ){
        this.mEventEntity = eventEntity;
        this.mParentScript = gameLayer;
        this.mParentScript.btnSkipNode.active = false;
        this.lbDesc.string = `${this.mEventEntity.desc}。但是彩票店老板突然跑过来，拉住你要求你给他一些分红`;
        this.userNode.active = true;
        this.moneyNode.active = true;
        this.moneyNode.getChildByName("lbMoney").color = cc.color( 113 , 210 , 110  );
        this.moneyNode.getChildByName("lbMoney").getComponent(cc.Label).string = `+${this.mEventEntity.effectParams[0].value}`;
        this.mParentScript.gameManager.effectParamsDealWith( this.mEventEntity.effectParams );
    }

    /**
     * 选择
     * @param e
     * @param define
     */
    async onBtnChoose( e , define : string) {
        let effectParams : { key : number,value : number }[] = [];
        switch (define) {
            case "1":
                //选择1
                effectParams.push({ key:EventParamsTypeConstant.MONEY,value:-20});
                let itemEntity : RegisterSpecialEventEntity = {
                    startHours : 0,
                    waitHours : 0,
                    type : 1,
                    desc : "只有合作才能共赢",
                    effectParams : effectParams
                };
                cc.tween(this.node).to(.5,{scale:0},{easing:cc.easing.backIn}).call(()=>{
                    this.mParentScript.setNoticeEventShow( itemEntity );
                    this.node.destroy();
                    this.node.removeFromParent();
                }).start();
                break;
            case "2":
                effectParams.push({ key:EventParamsTypeConstant.MONEY,value:-(20+this.mEventEntity.effectParams[0].value)});
                let itemEntity2 : RegisterSpecialEventEntity = {
                    startHours : 0,
                    waitHours : 0,
                    type : 1,
                    desc : "老板听了后,胖揍了你一顿,除了把你刚刚中到的钱抢来了以外,另外还多薅了20块钱，留下了一句下不为例哦~",
                    effectParams : effectParams
                };
                // cc.tween(this.node).to(.5,{scale:0},{easing:cc.easing.backIn}).call(()=>{
                    this.mParentScript.setNoticeEventShow( itemEntity2 );
                    this.node.destroy();
                    this.node.removeFromParent();
                // }).start();
                break;
        }
    }
}
